import React from 'react';
import Head from 'next/head';
import NextLink from 'next/link';
import { Box, Button, Container, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function Notfound() {
  return (
    <Box
      component="main"
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <img
              alt="Under development"
              src={require(`../assets/images/logo.png`)}
              style={{
                marginTop: 50,
                display: 'inline-block',
                maxWidth: '100%',
                width: 560,
              }}
            />
          </Box>
          <Typography align="center" color="textPrimary" variant="h4">
            404 <br />
            La page que vous demandez est introuvable
          </Typography>
          <Typography align="center" color="textPrimary" variant="subtitle2">
            Soit vous avez essayé une route louche, soit vous êtes venu ici par
            erreur. Quoi qu'il en soit, essayez d'utiliser la navigation
          </Typography>

          <NextLink href="/" passHref>
            <Button
              component="a"
              startIcon={<ArrowBackIcon fontSize="small" />}
              sx={{ mt: 3 }}
              variant="contained"
            >
              Go back to dashboard
            </Button>
          </NextLink>
        </Box>
      </Container>
    </Box>
  );
}

export default Notfound;
